export default {
  header: {
    projectName: 'プロジェクト名',
    export: 'エクスポート',
    debug: 'デバッグ',
    success: '成功',
    failed: '失敗',
    generating: '動画を生成中...',
    updateNameFailed: 'プロジェクト名の更新に失敗しました',
    menu: 'メニュー',
    settings: '設定',
    shortcuts: 'キーボードショートカット',
    about: '情報',
    darkMode: 'ダークモード',
    lightMode: 'ライトモード',
    settingsComingSoon: '設定機能は近日公開予定',
    shortcutsComingSoon: 'ショートカット機能は近日公開予定',
    aboutComingSoon: '情報は近日公開予定',
    language: '言語',
    dimensions: 'サイズ',
    canvas: 'キャンバス',
    view: '表示',
    general: '一般'
  },
  menu: {
    media: 'メディア',
    text: 'テキスト'
  },
  loading: {
    core: 'コア読み込み中...'
  },
  home: {
    title: 'GeminiXiang Studio',
    version: 'パブリックベータ',
    betaDisclaimer: 'ベータ版のため、データの保存は保証されません',
    newProject: '新規プロジェクト',
    backupFolder: 'バックアップフォルダ',
    documentation: 'ドキュメント',
    recentProjects: '最近のプロジェクト',
    viewAll: 'すべて表示 ({count})',
    noProjects: 'プロジェクトはまだありません。最初のプロジェクトを作成して始めましょう！',
    login: 'ログイン',
    github: 'GITHUB',
    discord: 'DISCORD',
    blog: 'ブログ',
    projectCreated: 'プロジェクト作成完了',
    projectCreatedDesc: '新しいプロジェクトが正常に作成されました',
    projectDeleted: 'プロジェクト削除完了',
    projectDeletedDesc: 'プロジェクトが正常に削除されました',
    deleteConfirmation: 'このプロジェクトを削除してもよろしいですか？この操作は取り消せません。',
    migrationFailed: '移行失敗',
    migrationFailedDesc: 'localStorageからのデータ移行に失敗しました',
    loadFailed: '読み込み失敗',
    loadFailedDesc: 'プロジェクトの読み込みに失敗しました',
    creationFailed: '作成失敗',
    creationFailedDesc: '新規プロジェクトの作成に失敗しました',
    deletionFailed: '削除失敗',
    deletionFailedDesc: 'プロジェクトの削除に失敗しました'
  },
  timeline: {
    autoSaveFailed: '自動保存失敗',
    autoSaveFailedDesc: 'プロジェクトの自動保存に失敗しました',
    loadFailed: '読み込み失敗',
    loadFailedDesc: 'プロジェクトの読み込みに失敗しました。ホームにリダイレクトします...',
    mainTrack: 'メイントラック',
    undo: '元に戻す',
    redo: 'やり直し',
    split: '分割',
    delete: '削除'
  },
  attributes: {
    properties: 'プロパティ',
    position: '位置',
    scale: 'スケール',
    animation: 'アニメーション',
    basic: '基本',
    mute: 'ミュート',
    text: 'テキスト',
    fontSize: 'フォントサイズ',
    content: '内容',
    fontFamily: 'フォントファミリー',
    direction: 'テキストの方向',
    color: '色',
    stroke: 'ストローク',
    background: '背景',
    video: '動画',
    rotate: '回転',
    backgroundColor: '背景色',
    opacity: '不透明度',
    blend: 'ブレンド',
    filter: 'フィルター',
    effect: 'エフェクト',
    transition: 'トランジション',
    speed: '速度',
    volume: '音量'
  },
  router: {
    timeline: '動画エディター',
    preview: 'プレビュー',
    storyboard: 'ストーリーボード - AI動画エージェント'
  },
  placeholder: {
    text: 'テキスト内容を入力してください',
    input: '入力してください'
  },
  error: {
    parseAudio: '音声の解析に失敗しました',
    parseImage: '画像の解析に失敗しました',
    parseVideo: '動画の解析に失敗しました',
    noProject: '最初にプロジェクトを作成または開いてください',
    invalidFileType: '無効なファイル形式'
  },
  media: {
    video: '動画',
    image: '画像',
    audio: '音声',
    dropToUpload: 'ここにファイルをドロップしてアップロード'
  },
  common: {
    defaultText: 'デフォルトテキスト',
    delete: '削除'
  }
};
